import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

export type CasinoGamesTreeGroupApi = {
  provider: string;
  sub: string;
  total: number;
  active: number;
  matched_total?: number | null;
};

export type CasinoGamesTreeResponse = {
  collection_total?: number;
  collection_active?: number;
  groups?: CasinoGamesTreeGroupApi[];
};

export function casinoGamesTreeGroupKey(provider: string, sub: string): string {
  return `${provider}::${sub}`;
}

export async function fetchCasinoGamesTree(
  search: string,
): Promise<CasinoGamesTreeResponse> {
  const token = JSON.parse(localStorage.getItem("token") ?? "null");
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);

  const params: { search?: string } = {};
  const trimmed = search.trim();
  if (trimmed) params.search = trimmed;

  const { data: responseBody } = await instance.get(API_ROUTES.GET_ADMIN_GAMES_TREE, {
    params,
  });
  if (responseBody?.success === false) {
    throw new Error(responseBody?.message || "Failed to fetch games tree");
  }
  const payload = responseBody?.data;
  if (!payload || typeof payload !== "object") return { groups: [] };
  return payload as CasinoGamesTreeResponse;
}
